export default __webpack_public_path__ + "static/media/icon_person_female.8bfc4493.png";